import React from "react";
import "./QuestApprovers.scss";

import { ITableDataMapping } from "../../../Model/UI";
import { IQuestTab } from "../../../Model/ServerResponse";
import { TableComponent } from "../../TableComponent/TableComponent";
import { TableCell, TableRow } from "@mui/material";
import Utility from "../../../common/utilities";

export interface IQuestApproversProp {
  questApproversTabData: IQuestTab | undefined;
}

export function QuestApprovers(props: IQuestApproversProp){
  let tableHeaderMapping: ITableDataMapping[] = [
    {
      id: "approverType",
      label: "Level/Code",
    },
    {
      id: "approverName",
      label: "Approver",
    },
    {
      id: "jobTitle",
      label: "Job Title",
    },
    {
      id: "status",
      label: "Status",
    },
    {
      id: "actionDate",
      label: "Action Date",
    },
    {
      id: "comments",
      label: "Approver Comment",
    },
  ];

  return <div data-testid="quest-approvers-tab" className="quest-approvers-tab">{tabUI()}</div>;

  function tabUI() {
    if (
      props.questApproversTabData &&
      !Utility.isArrayEmpty(props.questApproversTabData.data)
    ) {
      return (
        <TableComponent
          tableData={props.questApproversTabData.data}
          mappingTableData={tableHeaderMapping}
          getTableRow={getTableApproversRow}
        ></TableComponent>
      );
    } else {
      return <div className="no-approvers">No Approvers</div>;
    }
  }

  function getTableApproversRow(index: number, row: any){
    return (
      <>
        <TableRow className="spacing"></TableRow>
        <TableRow className="main-row" key={index}>
          <TableCell className="approval-level">{row.approverType}</TableCell>
          <TableCell className="approver-name">{row.approverName}</TableCell>
          <TableCell className="job-title">{row.jobTitle}</TableCell>
          <TableCell data-testid="approver-status-cell"
            className={Utility.mergeCssClassNames([
              "quest-approvers-tab",
              getApproverStatusStyle(row.status),
            ])}
          >
            {row.status}
          </TableCell>
          <TableCell className="action-date">{row.actionDate}</TableCell>
          <TableCell className="comments">{row.comments}</TableCell>
        </TableRow>
      </>
    );
  }

  function getApproverStatusStyle(status: string): string {
    let result = "";
    switch (status.toLowerCase()) {
      case "approved":
        result = "approved";
        break;
      case "rejected":
        result = "rejected";
        break;
      case "pending":
        result = "pending";
        break;
      default:
        return "";
    }
    return result;
  }
}
